import React, { useState, useEffect } from 'react';

interface SinglesPopupProps {
  onClose: () => void;
}

const SinglesPopup: React.FC<SinglesPopupProps> = ({ onClose }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  
  // Move the popup around randomly with increased movement
  useEffect(() => {
    const moveInterval = setInterval(() => {
      const randomX = Math.floor(Math.random() * 80) - 40; // -40 to 40px (increased range)
      const randomY = Math.floor(Math.random() * 80) - 40; // -40 to 40px (increased range)
      
      setPosition(prev => ({
        x: prev.x + randomX,
        y: prev.y + randomY
      }));
    }, 1500); // Reduced interval for more frequent movement
    
    return () => clearInterval(moveInterval);
  }, []);
  
  const popupStyle = {
    transform: `translate(${position.x}px, ${position.y}px)`,
    transition: 'transform 0.5s ease-in-out'
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
      <div 
        className="w-full max-w-sm p-4 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-xl border-4 border-pink-300 pointer-events-auto"
        style={popupStyle}
      >
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-2xl font-bold text-white animate-pulse">GÆRNE KJÆRRINGER ALERT!!</h2>
          <button 
            onClick={onClose}
            className="text-2xl font-bold text-white hover:text-pink-200"
          >
            X
          </button>
        </div>
        
        <div className="mb-4 flex">
          <div className="w-1/3 mr-3">
            <div className="h-32 bg-pink-300 rounded-lg overflow-hidden">
              <div className="w-full h-full bg-gradient-to-b from-transparent to-pink-900 flex items-end justify-center p-2">
                <span className="text-sm font-bold">Jessica, 24</span>
              </div>
            </div>
          </div>
          <div className="w-2/3">
            <p className="text-lg font-bold mb-2">
              GÆRNE KJÆRRINGER I DITT NÆROMRÅDE!!
            </p>
            <p className="text-sm mb-3">
              De er bare 2.3 kilometer unna og leter etter MORO I KVELD!!!
            </p>
            <div className="flex space-x-2 mb-2">
              <span className="inline-block px-2 py-1 bg-pink-700 rounded-full text-xs">Online nå</span>
              <span className="inline-block px-2 py-1 bg-pink-700 rounded-full text-xs">Klar til å chatte</span>
            </div>
          </div>
        </div>
        
        <div className="mb-3 p-2 bg-pink-700 rounded text-center">
          <p className="text-sm">
            "Jeg venter på en som DEG! Klikk nå for å chatte med meg!" - Samantha, 26
          </p>
        </div>
        
        <div className="flex space-x-2">
          <button 
            onClick={onClose}
            className="flex-1 py-2 bg-green-500 hover:bg-green-600 rounded-lg font-bold text-white"
          >
            CHAT NÅ!!
          </button>
          <button 
            onClick={onClose}
            className="flex-1 py-2 bg-blue-500 hover:bg-blue-600 rounded-lg font-bold text-white"
          >
            SE PROFILER
          </button>
        </div>
        
        <p className="mt-3 text-xs text-pink-200 text-center">
          ADVARSEL: Disse damene kan IKKE vente lenger! Du må være 18+ for å fortsette!!
        </p>
      </div>
    </div>
  );
};

export default SinglesPopup; 